<template>
  <svg
    width="346"
    height="66"
    viewBox="0 0 346 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.7616 48.451C34.941 51.6114 39.0308 53.5218 43.4353 53.9376C44.0617 53.9966 44.6939 54.0255 45.3311 54.0235C50.4501 54.0073 55.2565 51.9974 58.8651 48.3645L58.8876 48.3153C56.5967 50.5339 53.5942 51.7667 50.3956 51.7772C47.1151 51.7884 44.0285 50.5194 41.7023 48.2062C39.3753 45.8944 38.0889 42.8138 38.0781 39.5337C38.0675 36.2526 39.3354 33.1639 41.647 30.8369C44.3225 28.1432 44.3089 23.7889 41.6167 21.1125C38.9232 18.4353 34.5706 18.4505 31.896 21.1429C31.1299 21.9141 30.4246 22.729 29.7687 23.5745C27.3783 26.8484 26.0923 30.7822 26.1053 34.9122C26.1214 40.0337 28.1306 44.8418 31.7616 48.451Z"
      fill="url(#paint0_linear_184_545)"
    />
    <path
      d="M84.7098 41.4232C87.3854 38.7293 87.3716 34.376 84.6786 31.6996C81.9874 29.0223 77.6333 29.0369 74.9586 31.7306L59.0666 48.1518C59.0092 48.2096 58.9459 48.2588 58.8876 48.3153L58.8651 48.3645C55.2565 51.9974 50.4501 54.0073 45.331 54.0235C44.6938 54.0255 44.0616 53.9967 43.4352 53.9377C39.0307 53.5218 34.941 51.6114 31.7616 48.4511C28.1305 44.8419 26.1213 40.0338 26.1053 34.9123C26.0923 30.7823 27.3782 26.8485 29.7686 23.5746C26.2287 28.1374 24.313 33.7098 24.3314 39.5767C24.3533 46.5314 27.0816 53.0607 32.0124 57.9618C36.3301 62.2534 41.8836 64.8478 47.8648 65.4124C48.7154 65.4926 49.5739 65.5318 50.4394 65.5289C57.3908 65.507 63.9177 62.7776 68.8178 57.8445L84.7098 41.4232Z"
      fill="url(#paint1_linear_184_545)"
    />
    <path
      d="M55.803 17.1974C52.6236 14.0371 48.5339 12.1267 44.1294 11.7108C43.503 11.6518 42.8708 11.623 42.2336 11.625C37.1145 11.6412 32.3081 13.6511 28.6995 17.284L28.677 17.3332C30.9679 15.1145 33.9705 13.8818 37.169 13.8713C40.4495 13.8601 43.5362 15.1291 45.8624 17.4423C48.1894 19.754 49.4758 22.8346 49.4866 26.1148C49.4972 29.3959 48.2292 32.4846 45.9176 34.8116C43.2422 37.5053 43.2557 41.8596 45.948 44.5359C48.6414 47.2132 52.9941 47.1979 55.6687 44.5056C56.4348 43.7344 57.14 42.9195 57.796 42.0739C60.1864 38.8 61.4723 34.8663 61.4593 30.7362C61.4433 25.6148 59.4341 20.8066 55.803 17.1974Z"
      fill="url(#paint2_linear_184_545)"
    />
    <path
      d="M2.85485 24.2252C0.179237 26.9191 0.193043 31.2725 2.88601 33.9489C5.57722 36.6261 9.93134 36.6116 12.606 33.9179L28.498 17.4966C28.5554 17.4389 28.6188 17.3896 28.677 17.3332L28.6996 17.2839C32.3082 13.651 37.1146 11.6412 42.2336 11.6249C42.8708 11.6229 43.503 11.6518 44.1294 11.7108C48.5339 12.1266 52.6237 14.037 55.8031 17.1974C59.4341 20.8066 61.4433 25.6147 61.4594 30.7361C61.4724 34.8662 60.1865 38.8 57.796 42.0738C61.336 37.5111 63.2517 31.9386 63.2332 26.0718C63.2113 19.1171 60.483 12.5878 55.5522 7.68666C51.2346 3.39508 45.681 0.800704 39.6998 0.236076C38.8493 0.155897 37.9907 0.116702 37.1252 0.119595C30.1739 0.1415 23.6469 2.87086 18.7468 7.80396L2.85485 24.2252Z"
      fill="url(#paint3_linear_184_545)"
    />
    <path
      d="M101.729 53.0101H103.304C106.278 53.0101 107.853 51.3765 107.853 48.5758V18.9976H115.434V49.4511C115.434 56.6851 111.702 60.3023 103.596 60.3023H101.729L101.729 53.0101ZM106.862 10.0717C106.862 7.38801 108.961 5.34613 111.644 5.34613C114.326 5.34613 116.426 7.38801 116.426 10.0717C116.426 12.7554 114.326 14.7973 111.644 14.7973C108.961 14.7973 106.862 12.7554 106.862 10.0717Z"
      fill="#111827"
    />
    <path
      d="M121.731 33.8743C121.731 25.0067 128.613 18.2975 137.711 18.2975C146.808 18.2975 153.69 25.0067 153.69 33.8743C153.69 42.7419 146.808 49.4511 137.711 49.4511C128.613 49.4511 121.731 42.7419 121.731 33.8743ZM145.875 33.8743C145.875 29.207 142.434 25.6485 137.711 25.6485C133.045 25.6485 129.546 29.207 129.546 33.8743C129.546 38.5416 133.045 42.1001 137.711 42.1001C142.434 42.1001 145.875 38.5416 145.875 33.8743Z"
      fill="#111827"
    />
    <path
      d="M160.103 6.74622H167.684V22.4982C170.075 19.8728 173.4 18.2975 177.366 18.2975C185.647 18.2975 191.829 25.0067 191.829 33.8743C191.829 42.7419 185.647 49.4511 177.366 49.4511C173.4 49.4511 170.075 47.8757 167.684 45.2508V48.751H160.103V6.74622ZM184.014 33.8743C184.014 29.207 180.573 25.6485 175.849 25.6485C171.184 25.6485 167.684 29.207 167.684 33.8743C167.684 38.5416 171.184 42.1001 175.849 42.1001C180.573 42.1001 184.014 38.5416 184.014 33.8743Z"
      fill="#111827"
    />
    <path
      d="M198.301 18.9976H205.882V22.0895C208.098 19.5811 211.072 18.2975 214.688 18.2975C218.946 18.2975 222.328 20.2229 224.136 23.4314C226.469 20.1064 229.968 18.2975 234.342 18.2975C240.873 18.2975 245.247 22.6731 245.247 29.3823V48.7511H237.666V31.6576C237.666 28.0404 235.391 25.6485 231.834 25.6485C228.101 25.6485 225.594 28.0987 225.594 31.7742V48.751H218.012V31.6576C218.012 28.0404 215.68 25.6485 212.181 25.6485C208.448 25.6485 205.882 28.0986 205.882 31.7741V48.751H198.301V18.9976Z"
      fill="#111827"
    />
    <path
      d="M251.485 33.8743C251.485 25.0067 257.725 18.2975 266.006 18.2975C269.972 18.2975 273.296 19.8729 275.687 22.4983V18.9976H283.268V48.751H275.687V45.2508C273.296 47.8758 269.972 49.4511 266.006 49.4511C257.725 49.4511 251.485 42.7419 251.485 33.8743ZM275.687 33.8743C275.687 29.207 272.188 25.6485 267.464 25.6485C262.799 25.6485 259.3 29.207 259.3 33.8743C259.3 38.5416 262.798 42.1001 267.464 42.1001C272.188 42.1001 275.687 38.5416 275.687 33.8743Z"
      fill="#111827"
    />
    <path
      d="M294.173 39.3582V25.9402H289.449V18.9976H292.132C293.706 18.9976 294.581 18.181 294.581 16.6057V11.0635H301.754V18.9976H308.636V25.9402H301.754V38.0751C301.754 40.4083 303.212 41.8088 305.662 41.8088H308.636V48.7511H304.554C297.73 48.7511 294.173 45.4839 294.173 39.3582Z"
      fill="#111827"
    />
    <path
      d="M313.184 33.8743C313.184 25.0067 320.066 18.2975 329.163 18.2975C338.261 18.2975 345.143 25.0067 345.143 33.9913C345.143 34.8079 345.084 35.7414 344.909 36.4997H321.29C322.282 40.35 325.373 42.8589 329.455 42.8589C332.546 42.8589 335.112 41.4588 336.453 39.5334H344.676C342.401 45.4256 336.511 49.4511 329.28 49.4511C320.066 49.4511 313.184 42.7419 313.184 33.8743ZM321.348 30.9576H337.037C336.103 27.3403 333.071 24.8902 329.163 24.8902C325.314 24.8902 322.398 27.2821 321.348 30.9576Z"
      fill="#111827"
    />
    <defs>
      <linearGradient
        id="paint0_linear_184_545"
        x1="42.4965"
        y1="19.1141"
        x2="42.4965"
        y2="54.0236"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.014" stop-color="#572EA9" />
        <stop offset="1" stop-color="#6538BF" stop-opacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_184_545"
        x1="32.0298"
        y1="57.9793"
        x2="71.5037"
        y2="18.5198"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.3417" stop-color="#572EA9" />
        <stop offset="0.8524" stop-color="#6538BF" stop-opacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_184_545"
        x1="45.0682"
        y1="46.5343"
        x2="45.0682"
        y2="11.6248"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2831" stop-color="#ED1F6B" />
        <stop offset="1" stop-color="#A3154A" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_184_545"
        x1="16.0753"
        y1="47.1431"
        x2="55.5493"
        y2="7.68351"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5419" stop-color="#EB4571" />
        <stop offset="1" stop-color="#EB4571" stop-opacity="0.6" />
      </linearGradient>
    </defs>
  </svg>
</template>
